// app/javascript/projects/components/ProjectsDisplay.jsx
import React, { useState } from 'react';
import { useCode } from '../../../hooks/codes/queries';
import CodingConstants from 'constants/CodingConstants'
import ColorConstants from 'constants/ColorConstants'
import SubElementComponent from './SubElementComponent';

const PADDING_PX = "8";

const createStyle = (color) => {
  return {
    boxShadow: `0 ${PADDING_PX}px 0 0 ${color}, 0 -${PADDING_PX}px 0 0 ${color}`,
    backgroundColor: color
  }
}

const HIGHLIGHT_STYLE = createStyle(ColorConstants.HIGHLIGHT_COLOR);
const HOVER_STYLE = createStyle(ColorConstants.HOVER_COLOR);

const SentenceComponent = (props) => {
  const [mouseInside, setMouseInside] = useState(false);
  
  // Fetch codes from cache using the extracted codeIds
  const { data: primeCode } = useCode(props.primeCodeId);

  const getExcerptId = () => {
    return (props.codedSentence || {}).excerptId || null;
  }

  const containsExcerptId = (excerptId) => {
    if (!excerptId) return false;
    return ((props.codedSentence || {}).excerptIds || []).includes(excerptId);
  }

  const onMouseEnter = (event) => {
    if ((props.isPrint && !props.enableHover) || !props.hasEditPermission) return;
    props.onHover(getExcerptId())
    setMouseInside(true);
  }

  const onMouseLeave = (event) => {
    if ((props.isPrint && !props.enableHover) || !props.hasEditPermission) return;
    props.onHover(null)
    setMouseInside(false);
  }
  
  let sentenceElements = []
  
  if (props.codedSentence) {
    sentenceElements = props.codedSentence.selectElements.map((selectElement, index) => {
      const subElements = selectElement.elements.map((subElement, subIndex) => (
        <SubElementComponent 
          subElement={subElement} 
          subIndex={subIndex} 
          primeCode={primeCode} 
          key={subIndex} 
        />
      ));

      if (selectElement.style == CodingConstants.SELECTED) {
        return <span 
          data-highlight-index={index} 
          className="highlightSpan" 
          key={index}
          style={HIGHLIGHT_STYLE}
          onMouseLeave={onMouseLeave}>
          {subElements}
        </span>
      } else {
        const isCurrentExcerpt = containsExcerptId(props.hoverExcerptId);
        const style = (mouseInside || props.paragraphHover || isCurrentExcerpt) ?
          HOVER_STYLE : {};
        
        return <span 
          data-highlight-index={index} 
          className="highlightSpan" 
          key={index}
          style={style}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}>
          {subElements}
        </span>
      }
    });
  }

  return (
    <span 
      data-sentence-index={props.index}
      excerpt-id={getExcerptId()}
      className="sentenceSpan"
      style={props.hasEditPermission ? {cursor:"pointer",} : {cursor:"default"}}
    >
      {sentenceElements}
    </span>
  );
}

export default SentenceComponent;